<template>
  <el-card>
    <el-form label-width="100px" label-position="left">
      <el-form-item label="物料名称" prop="materialName">
        {{ formData.materialName }}
      </el-form-item>
      <el-form-item label="物料编码" prop="materialCode">
        {{ formData.materialCode }}
      </el-form-item>
      <el-form-item label="物料分类" prop="materialTypeId">
        {{ formData.materialTypeName }}
      </el-form-item>
      <el-form-item label="单位" prop="company">
        {{ formData.company }}
      </el-form-item>
      <el-form-item label="规格" prop="specifications">
        {{ formData.specifications }}
      </el-form-item>
      <el-form-item label="供应商名称" prop="supplierName">
        {{ formData.supplierName }}
      </el-form-item>
      <el-form-item label="状态" prop="state">
        {{ formData.state === '1' ? '启用' : '禁用' }}
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'ManageDetail',
  components: {
  },
  data () {
    return {
      formData: {
        materialName: '', // 物料名称
        materialCode: '', // 物料编码
        materialTypeId: '', // 物料分类
        materialTypeName: '',
        company: '', // 单位
        specifications: '', // 规格
        state: '1' // 状态1启用2禁用
      }
    }
  },
  computed: {
    materialTypeId () {
      return this.$route.query.materialTypeId
    }
  },
  watch: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$axios.get(this.$apis.material.selectYhMaterialByMaterialId, {
        materialId: this.materialId
      }).then(res => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
